<template>
  <div class="login-container">
    <div class="container-lf">
      <h1>变色龙智能创意平台</h1>
      <h3>一站式创意解决方案平台</h3>
      <p>
        优质创意智能生成，创意数据全方位监测，助力提升营销效果<br />
        强大的编辑能力，操作便捷高效，一键即可生成千人千面的创意
      </p>
      <div class="layer">
        <layer-svg></layer-svg>
      </div>
    </div>
    <div class="container-rt">
      <img src="../../src/assets/images/logo.png" alt="" />
      <div class="form">
        <div class="login-input">
          <svg class="svg-icon" aria-hidden="true">
            <use xlink:href="#icon-username"></use>
          </svg>
          <input type="text" placeholder="请输入您的用户名" v-model="name" />
        </div>
        <div class="login-input">
          <svg class="svg-icon" aria-hidden="true">
            <use xlink:href="#icon-password"></use>
          </svg>
          <input
            type="password"
            placeholder="请输入您的密码"
            v-model="password"
          />
        </div>
        <el-button class="button" type="primary" @click="formLogin">
          登 录
        </el-button>
        <span @click="login">员工登录</span>
      </div>
    </div>
  </div>
</template>

<script>
import config from 'utils/config';
import _ from 'lodash';
import LayerSvg from '../pages/home/Svg';
import Axios from 'utils/axios';

export default {
  components: {
    'layer-svg': LayerSvg
  },
  data() {
    return {
      name: '',
      password: ''
    };
  },
  methods: {
    login() {
      const return_url = _.isEmpty(this.$route.query.return_url)
        ? encodeURIComponent(`http://${window.location.host}/template`)
        : this.$route.query.return_url;
      window.location.href = `${config.HOST}/admin/login?accessToken=${config.ACCESS_TOKEN}&return_url=${return_url}`;
    },
    formLogin() {
      if (this.name.length === 0) {
        this.$message('用户名不能为空');
        return;
      } else if (this.password.length === 0) {
        this.$message('密码不能为空');
        return;
      }
      Axios.get('/user/login', {
        params: { account: this.name, password: this.password }
      }).then(res => {
        console.log(res);
        localStorage.setItem('accessToken', res.Token);
        localStorage.setItem('userName', res.Account.name);
        localStorage.setItem(
          'authority',
          JSON.stringify(res.Account.authority)
        );
        const return_url = _.isEmpty(this.$route.query.return_url)
          ? `http://${window.location.host}/template`
          : decodeURIComponent(this.$route.query.return_url);
        if (res.Token) {
          window.location.href = return_url;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  width: 100%;
  min-width: 1200px;
  min-height: 600px;
  height: 100vh;
  display: flex;
  flex-wrap: nowrap;
  .container-lf {
    width: 58.6%;
    flex: none;
    background: url('../../src/assets/images/login_bg.jpg') no-repeat top right;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .layer {
      width: 426px;
      margin: 24px 0;
    }
    > h1 {
      width: 450px;
      font-size: 50px;
      height: 70px;
      color: white;
      margin: 0;
    }
    > h3 {
      width: 450px;
      font-size: 26px;
      font-weight: 500;
      height: 37px;
      margin: 0;
      margin-bottom: 29px;
      color: white;
    }
    > p {
      width: 450px;
      margin: 0;
      margin-bottom: 86px;
      color: white;
      opacity: 0.6;
    }
  }
  .container-rt {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > img {
      width: 255px;
      margin-bottom: 48px;
    }
    .form {
      display: flex;
      flex-direction: column;
      .button {
        width: 266px;
        height: 46px;
        margin-top: 56px;
        font-size: 18px;
      }
      > span {
        font-size: 14px;
        font-weight: 500;
        letter-spacing: -0.39px;
        color: #3fb7ff;
        cursor: pointer;
        align-self: flex-end;
        margin-top: 12px;
      }
      .login-input {
        &:first-child {
          margin-bottom: 39px;
        }
        width: 266px;
        padding-bottom: 9px;
        border-bottom: 1px solid #9b9b9b;
        .svg-icon {
          font-size: 19px;
          color: #75808b;
          margin-right: 18px;
        }
        > input {
          border: none;
          outline: none;
          width: 200px;
          font-size: 16px;
          &::placeholder {
            color: rgba(117, 128, 139, 0.85);
          }
        }
      }
    }
  }
}
</style>
